<template>
    <div id="request" uk-modal="center: true">
        <div class="uk-modal-dialog">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <header class="uk-modal-header">
                <h2 class="uk-modal-title">Сделать запрос</h2>
            </header>
            <div class="uk-modal-body" v-if="feedback_id === null">
                <form>
                    <fieldset class="uk-fieldset">

                        <div class="uk-margin">
                            <input name="customer" v-validate="'required|alpha'"
                                   :class="{'uk-form-danger': errors.has('customer') }" v-model="formData.ShopFeedback.customer"
                                   class="uk-input" type="text" placeholder="Имя *">
                        </div>

                        <div class="uk-margin">
                            <input name="phone" v-validate="rules.phone"
                                   :class="{'uk-form-danger': errors.has('phone') }" v-model="formData.ShopFeedback.phone"
                                   class="uk-input" type="text" placeholder="Телефон *">
                        </div>

                        <div class="uk-margin">
                            <input placeholder="E-mail" :class="{' uk-form-danger': errors.has('email')}"
                                   v-validate="{ required: true, email: true }" name="email"
                                   v-model="formData.ShopFeedback.email" class="uk-input" type="email">
                        </div>

                        <div class="uk-margin">
                            <input v-model="formData.ShopFeedback.time" class="uk-input" type="text"
                                   placeholder="Удобное время для звонка">
                        </div>

                        <div class="uk-margin">
                            <textarea v-model="formData.ShopFeedback.message" class="uk-textarea" rows="5"
                                      placeholder="Сообщение"></textarea>
                        </div>

                    </fieldset>
                </form>
                <p>
                    <b>График работы</b>
                    <br>пн-пт 9:00-18:00
                </p>
                <p>Если вы оставили запрос в нерабочее время, он будет обработан в начале следующего рабочего дня.</p>
            </div>
            <div class="uk-modal-body" v-else>
                <p>Ваш запрос успешно отправлен!</p>
                <p>Если вы оставили запрос в нерабочее время, он будет обработан в начале следующего рабочего дня.</p>
                <p>
                    <b>График работы</b>
                    <br>пн-пт 9:00-18:00
                </p>
            </div>
            <div class="uk-modal-footer uk-text-right">
                <button class="uk-button uk-button-default uk-modal-close" type="button">Закрыть</button>
                <button v-if="feedback_id === null" @click="send" class="uk-button uk-button-secondary" type="button">
                    Отправить
                </button>
            </div>
        </div>
    </div>

</template>
<script>

    export default {
        data() {
            return {
                loading: false,
                feedback_id: null,
                formData: {
                    ShopFeedback: {
                        customer: '',
                        phone: '',
                        email: '',
                        time: '',
                        message: '',
                    }
                },
                rules: {
                    phone: {required: true, regex: /^([0-9\s\-\+\(\)]{7,})$/}
                }
            }
        },
        methods: {
            send() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading = true;
                        this.$http.post('/feedback/send', this.formData).then(response => {
                            this.feedback_id = response.body.data.id;
                            this.loading = false;
                        }, response => {
                        })
                    }

                });

            }
        }
    }
</script>



// WEBPACK FOOTER //
// Callback.vue?ed982856